import { Table } from './styles';

const TableSort = (props: any) => {
  const { columns, ...otherTableProps } = props;

  const sortableColumns = columns.map((column: any) => {
    const { sorter, dataIndex, ...otherColumnProps } = column;

    if (sorter) {
      const { compare, ...otherSorterProps } = sorter;

      return {
        ...otherColumnProps,
        dataIndex,
        sorter: {
          // compare: (rowA: any, rowB: any) => compare(rowA[dataIndex], rowB[dataIndex]),
          ...otherSorterProps,
        },
      };
    }

    return column;
  });

  return <Table className="tableSort" columns={sortableColumns} {...otherTableProps} />;
};

export default TableSort;
